// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"Footer_emailInput__THQ32","emailInputGroup":"Footer_emailInputGroup__3SiU9","submitIcon":"Footer_submitIcon__Am1FW","link":"Footer_link__Cdl5E"};